import React from 'react';
import SizeStrategyDropdown from './SizeStrategyDropdown';

const SizeSettingsLayout = ({
  children,
  label,
  columnSizeStrategy,
  setColumnSizeStrategy,
}: {
  children: JSX.Element | JSX.Element[] | null;
  label?: JSX.Element;
  columnSizeStrategy: FleetOps.ColumnSizeStrategies.Strategy | undefined;
  setColumnSizeStrategy: React.Dispatch<
    React.SetStateAction<FleetOps.ColumnSizeStrategies.Strategy | undefined>
  >;
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <div>
        {label}
        <SizeStrategyDropdown
          columnSizeStrategy={columnSizeStrategy}
          setColumnSizeStrategy={setColumnSizeStrategy}
        />
        {children}
      </div>
    </div>
  );
};

export default SizeSettingsLayout;
